module.exports = __webpack_public_path__ + "static/media/BANKBARODA.da2c9baf.txt";